export default __webpack_public_path__ + "static/media/suit-woman1.98e6e687.svg";